import api from '../../../services/api';

export interface EcommRevenueBreakdownParams {
  start_date: string;
  end_date: string;
  channel: string;
  kind: string;
  period_type: string;
}

export interface EcommRevenueBreakdownItem {
  date: string;
  revenue_value: number;
  profit_value: number;
}

export const fetchEcommRevenueBreakdown = async (
  params: EcommRevenueBreakdownParams
): Promise<EcommRevenueBreakdownItem[]> => {
  const response = await api.get('/api/shopify/revenue_breakdown', { params });
  return response.data.revenue_breakdown;
};
